type ErrorLeaf = string | boolean | number | null | undefined;

interface ErrorObject {
  [key: string]: ErrorNode;
}

type ErrorNode =
  | ErrorLeaf
  | ErrorObject
  | Array<ErrorObject | null>;

function hasNonArrayEntries(value: ErrorNode) {
  if (Array.isArray(value) || value === null || value === undefined) {
    return false;
  }

  return Object.keys(value as object).length > 0;
}

function doesArrayHaveError(arr: Array<ErrorObject | null>) {
  let hasError = false;

  arr.forEach(item => {
    if (item) {
      Object.keys(item).forEach(key => {
        const value = item[key];

        if (value && typeof value === 'object' && !Array.isArray(value) && Object.entries(value).length > 0) {
          hasError = true;
        }
      });
    }
  });

  return hasError;
}

function getStringFromErrorArray(errorObj: ErrorObject, returnString: string) {
  const arrayValue = errorObj[returnString];

  if (!Array.isArray(arrayValue)) {
    return returnString;
  }

  for (const [index, item] of arrayValue.entries()) {
    if (!item) {
      continue;
    }

    const firstKey = Object.keys(item)[0];
    const nestedValue = item[firstKey];

    if (
      nestedValue &&
      typeof nestedValue === 'object' &&
      !Array.isArray(nestedValue) &&
      Object.keys(nestedValue).length > 0
    ) {
      returnString += `[${index}].`;
      const innerKey = Object.keys(item)[0];
      returnString += `${innerKey}`;

      if (typeof item[innerKey] !== 'string') {
        returnString += `.${Object.keys(item[innerKey] as ErrorObject)[0]}`;
      }

      break;
    }
  }

  return returnString;
}

function isErrorFieldValue(value: ErrorNode) {
  return (
    (hasNonArrayEntries(value) && !Array.isArray(value)) ||
    (Array.isArray(value) && doesArrayHaveError(value))
  );
}

function getFirstErrorKey(errorObj: ErrorObject) {
  return Object.keys(errorObj).find(item => isErrorFieldValue(errorObj[item]));
}

function getStringFromNestedObject(currentValue: ErrorNode, returnString: string) {
  if (!currentValue || typeof currentValue !== 'object' || Array.isArray(currentValue)) {
    return returnString;
  }

  if (Object.entries(currentValue).length === 0) {
    return returnString;
  }

  const childObj = currentValue as ErrorObject;
  const keys = Object.keys(childObj);

  if (keys.length === 0) {
    return returnString;
  }

  const childKey = keys[0];
  returnString += `.${childKey}`;

  if (childObj[childKey] && typeof childObj[childKey] !== 'string') {
    returnString += `.${Object.keys(childObj[childKey] as ErrorObject)[0]}`;
  }

  return returnString;
}

export function getFieldNameFromErrorObject(errorObj: ErrorObject) {
  const returnString = getFirstErrorKey(errorObj);

  if (!returnString) {
    return null;
  }

  if (Array.isArray(errorObj[returnString])) {
    return getStringFromErrorArray(errorObj, returnString);
  }

  return getStringFromNestedObject(errorObj[returnString], returnString);
}